export const NOTIFICATIONS_PAGE_SIZE = 20;

/** getNotificationCount(nIsRead: false) → count of unread notifications for bell dot. */
export const UNREAD_NOTIFICATION_COUNT_FILTER = false;
